<template>
    <div v-if="$store.getters.getLoggedIn === true" class="top-header d-print-none">
        <div class="container-fluid">
            <div class="header-content-flex">
                <div class="logo-header">
                    <i class="siscont icon_menu" type="button" v-if="$store.getters.isMobile" @click="toggleSidebar" id="openSideBar" />
                    <p class="title-module">
                        {{ $store.getters.getHeaderTitle }}
                    </p>
                </div>
                <EnvironmentBadge :inline="true" />
                <div class="d-flex align-items-center">
                    <div class="box-enterprise">
                        <button class="btn d-flex align-items-center" id="btnOpenModalEnterprise" data-bs-toggle="modal" href="#modalEnterprise" role="button">
                            <i class="siscont icon_location" />
                            {{ $store.state.enterprise.name }}
                        </button>
                    </div>
                    <div class="dropdown dropdown-account">
                        <i class="siscont icon_r_es_header" :class="resalesStatus ? 'active' : 'inactive'" title="Permite desativar o bloqueio de estado para revenda - ES" @click="disableResalesStatusLock()" v-if="$store.getters.checkPermissionsUser('use-disable-enterprise-status-stock')">R - ES</i>
                        <i class="siscont icon_r_header" :class="resaleStatus ? 'active' : 'inactive'" title="Permite desativar o bloqueio de estado para revenda" @click="disableResaleStatusLock()" v-if="$store.getters.checkPermissionsUser('use-disable-enterprise-status-stock')">R</i>
                        <i class="siscont icon_e_header" :class="enterpriseStockStatus ? 'active' : 'inactive'" title="Permite desativar a trava de Estoque" @click="disableEnterpriseStockReservation()" v-if="$store.getters.checkPermissionsUser('use-disable-enterprise-status-stock')">E</i>
                        <i class="siscont icon_question_header mx-2" type="button" @click="sendUrlStatus()" v-if="$store.getters.checkPermissionsUser('list-system-status') && !$store.getters.isMobile" />
                        <div id="noticeable-widget" v-if="!$store.getters.isMobile"></div>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButtonAccount">
                            <div class="user-infos d-flex align-items-center">
                                <div class="user-avatar">
                                    <i class="siscont icon_user_header" />
                                </div>
                                <div class="d-flex flex-column">
                                    <p class="user-name">{{ 'Olá, ' + getFirstName($store.getters.getUser.name) }}</p>
                                    <p class="user-email mb-0">{{ $store.getters.getUser.email }}</p>
                                </div>
                            </div>
                            <hr class="my-2 opacity-10" />
                            <li class="logout-area" @click="$store.dispatch('logout')">
                                <div class="d-flex align-items-center">
                                    <i class="siscont icon_new_sign_out me-2" />
                                    <span class="leave">Sair</span>
                                </div>
                                <i class="siscont icon_chevron_right" />
                            </li>
                        </ul>
                        <i class="siscont icon_user_header ms-2" type="button" id="dropdownMenuButtonAccount" data-bs-toggle="dropdown" aria-expanded="false" />
                        <p class="user-name-display mb-0 d-none d-lg-block">
                            {{ getFirstTwoNames($store.getters.getUser.name) }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalEnterprise :modalTitle="getModalTitle" :txtBtnModal="gettxtBtnModal" />
</template>

<script>
import store from '@/store';
import { config } from '../../src/config';
import ModalEnterprise from '../components/ModalEnterprise.vue';
import EnvironmentBadge from '@/components/EnvironmentBadge.vue';

export default {
    name: "MyHeader",
    components: {
        ModalEnterprise,
        EnvironmentBadge,
    },
    emits: ['toggle-sidebar'],
    data() {
        return {
            enterprise: null
        };
    },
    methods: {
        toggleSidebar() {
            this.$emit('toggle-sidebar');
        },
        disableResaleStatusLock() {
            const typeOrder = this.$store.getters.getTypeOrderById(process.env.VUE_APP_TYPE_ORDER_RESALE);
            this.updateTypeOrder(typeOrder);
        },
        disableResalesStatusLock() {
            const typeOrder = this.$store.getters.getTypeOrderById(process.env.VUE_APP_TYPE_ORDER_RESALES);
            this.updateTypeOrder(typeOrder);
        },
        disableEnterpriseStockReservation() {
            const enterprise = this.$store.getters.getEnterpriseById(process.env.VUE_APP_ENTERPRISE_HEADQUARTER);
            this.getEnterpriseById(enterprise);
        },
        async getEnterpriseById(enterprise) {
            this.showLoading = true;
            try {
                const requestOptions = await this.$store.dispatch('getRequestOptions', { addAuth: true, method: "GET", dataJson: false });
                const url = "/enterprise/" + enterprise.id;
                const dataRequest = await this.$store.dispatch('sendRequest', { url: url, requestOptions: requestOptions });
                if (dataRequest.request.status == 200) {
                    this.enterprise = dataRequest.response;
                    if (this.enterprise) {
                        this.updateEnterprise(this.enterprise);
                    }
                }
            } catch (error) {
                this.$store.dispatch('setModalMessage', {
                    message: error,
                    type: "error",
                });
            }
            this.showLoading = false;
        },
        async updateTypeOrder(form) {
            const data = JSON.parse(JSON.stringify(form));
            data.validate_pj_uf_equal = Number(data.validate_pj_uf_equal) === 1 ? 0 : 1;
            const dataJson = JSON.stringify(data);
            const requestOptions = await this.$store.dispatch('getRequestOptions', { addAuth: true, method: 'PUT', dataJson });
            const url = "/type-order/" + form.id;
            const dataRequest = await this.$store.dispatch('sendRequest', { url, requestOptions });
            if (dataRequest.request.status == 200) {
                let label = "Revenda";
                if (String(form.id) === String(process.env.VUE_APP_TYPE_ORDER_RESALES)) {
                    label = "Revenda - ES";
                } else if (String(form.id) === String(process.env.VUE_APP_TYPE_ORDER_RESALE)) {
                    label = "Revenda";
                }
                this.$store.dispatch('setModalMessage', {
                    message: `Bloqueio de estado para ${label} ${data.validate_pj_uf_equal === 1 ? 'Ativado com sucesso!' : 'Desativado com sucesso!'}`,
                    type: "success",
                });
                setTimeout(() => {
                    this.$store.dispatch('logout');
                }, 2000);
            }
            if (dataRequest.request.status == 422) {
                this.$store.dispatch('setModalMessage', {
                    message: dataRequest.response.message,
                    type: "error",
                });
            }
            this.showLoading = false;
        },
        async updateEnterprise(form) {
            const data = form;
            data.qty_stock_reservation = Number(data.qty_stock_reservation) === 1 ? 0 : 1;
            const dataJson = JSON.stringify(data);
            const requestOptions = await this.$store.dispatch('getRequestOptions', { addAuth: true, method: 'PUT', dataJson });
            const url = "/enterprise/" + form.id;
            const dataRequest = await this.$store.dispatch('sendRequest', { url, requestOptions });
            if (dataRequest.request.status == 200) {
                this.$store.dispatch('setModalMessage', {
                    message: `Trava de estoque ${data.qty_stock_reservation === 1 ? 'Ativado com sucesso!' : 'Desativado com sucesso!'}`,
                    type: "success",
                });
                setTimeout(() => {
                    this.$store.dispatch('logout');
                }, 2000);
            }
            if (dataRequest.request.status == 422) {
                this.$store.dispatch('setModalMessage', {
                    message: dataRequest.response.message,
                    type: "error",
                });
            }
            this.showLoading = false;
        },
        sendUrlStatus() {
            this.$router.push('/all-status');
        },
        getFirstTwoNames(fullName) {
            if (!fullName) return '';
            const normalized = fullName.trim().replace(/\s+/g, ' ');
            const parts = normalized.split(' ').slice(0, 2);
            return parts.map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()).join(' ');
        },
        getFirstName(fullName) {
            if (!fullName) return '';
            return fullName.trim().split(/\s+/)[0];
        }
    },
    computed: {
        resaleStatus() {
            const resaleId = Number(process.env.VUE_APP_TYPE_ORDER_RESALE);
            let typeOrders = this.$store.state.typeOrders;
            if (!typeOrders || !typeOrders.length) {
                const storageTypeOrders = localStorage.getItem('type_orders');
                if (storageTypeOrders) {
                    typeOrders = JSON.parse(storageTypeOrders);
                }
            }
            const typeOrder = typeOrders?.find(t => t.id === resaleId);
            return Number(typeOrder?.validate_pj_uf_equal) === 1;
        },
        enterpriseStockStatus() {
            const enterprise = this.$store.getters.getEnterpriseById(process.env.VUE_APP_ENTERPRISE_HEADQUARTER);
            return Number(enterprise?.qty_stock_reservation) === 1;
        },
        getModalTitle() {
            return this.$store.getters.getEnterpriseId ? "Altere a empresa" : "Selecione a empresa";
        },
        gettxtBtnModal() {
            return this.$store.getters.getEnterpriseId ? "Atualizar" : "Selecionar";
        },
        resalesStatus() {
            const resaleId = Number(process.env.VUE_APP_TYPE_ORDER_RESALES);
            let typeOrders = this.$store.state.typeOrders;
            if (!typeOrders || !typeOrders.length) {
                const storageTypeOrders = localStorage.getItem('type_orders');
                if (storageTypeOrders) {
                    typeOrders = JSON.parse(storageTypeOrders);
                }
            }
            const typeOrder = typeOrders?.find(t => t.id === resaleId);
            return Number(typeOrder?.validate_pj_uf_equal) === 1;
        }
    },
    mounted() {
        if (this.$store.getters.getLoggedIn === true) {
            this.$nextTick(function () {
                window.noticeable.render('widget', config.noticeable.iconWidgetId, { selector: '#noticeable-widget' });
            });
        }
    },
    unmounted() {
        if (this.$store.getters.getLoggedIn === true) {
            window.noticeable.destroy('widget', config.noticeable.iconWidgetId);
        }
    }
};
</script>